import React, { Component } from "react";
import { API, Storage, Auth } from "aws-amplify";


export default class DoctorsList extends Component {

  constructor(props){
     super(props);
     this.state ={

     };
  }

  async componentDidMount(){

      const doctorsList = await this.getDoctorsListFromServer();
      var doctorsListWithProfilePic = []
      for(var i = 0 ; i < doctorsList.length; i++){
        var eachDoctor = doctorsList[i];

        if(eachDoctor.profilePic && eachDoctor.profilePic.length > 0){
          eachDoctor.profilePicUrl = await Storage.get(eachDoctor.profilePic);

        }

        doctorsListWithProfilePic.push(eachDoctor);
      }

      this.setState({ doctorsList: doctorsListWithProfilePic });


  }

  async getDoctorsListFromServer(){
      return await API.get("retnetindia", "/doctors");
  }

  getEachDoctorHtml(doctorDetails){
     return(
         <div className="card">
             <div className="card-image">
                 <a href="#">

                     <img src={doctorDetails.profilePicUrl} className="img-center profile-pic "/>
                 </a>
             </div>
             <div className="card-caption-overlay card-caption-overlay--2 card-caption-overlay--animated" >
                 <div className="card-caption">
                     <div className="text-center">
                         <a href="#" className="heading heading-6 strong-500 mb-0">{doctorDetails.fullName}</a>
                         <span className="clearfix"></span>
                         <span className="text-sm">This is an overlay caption</span>
                     </div>
                     <div className="card-caption-hidden text-center">
                         <p className="mt-3">
                             Lorem ipsum dolor sit amet consectetur adipiscing elit sed.
                         </p>
                     </div>
                 </div>
             </div>
         </div>

     );
  }

  getEachRowHtml(doctor1, doctor2){
      return(
        <div className="row cols-md-space cols-sm-space cols-xs-space">
           <div className="col-lg-6">
               <div className="card">
                   <div className="card-image">
                       <a href="#">
                           <img src={doctor1.profilePicUrl} />
                       </a>
                   </div>
                   <div className="card-caption-overlay card-caption-overlay--2 card-caption-overlay--animated" >
                       <div className="card-caption">
                           <div className="text-center">
                               <a href="#" className="heading heading-6 strong-500 mb-0">{doctor1.fullName}</a>
                               <span className="clearfix"></span>
                               <span className="text-sm">This is an overlay caption</span>
                           </div>
                           <div className="card-caption-hidden text-center">
                               <p className="mt-3">
                                   Lorem ipsum dolor sit amet consectetur adipiscing elit sed.
                               </p>
                           </div>
                       </div>
                   </div>
               </div>
           </div>

           <div className="col-lg-6">
               {doctor2 ? <div className="card">
                               <div className="card-image">
                                   <a href="#">
                                       <img src={doctor2.profilePicUrl}/>
                                   </a>
                               </div>
                               <div className="card-caption-overlay card-caption-overlay--2 card-caption-overlay--dark card-caption-overlay--animated">
                                   <div className="card-caption">
                                       <div className="text-center">
                                           <a href="#" className="heading heading-6 strong-500 mb-0">{doctor2.fullName}</a>
                                           <span className="clearfix"></span>
                                           <span className="text-sm">This is an overlay caption</span>
                                       </div>
                                       <div className="card-caption-hidden text-center">
                                           <p className="mt-3">
                                               Lorem ipsum dolor sit amet consectetur adipiscing elit sed.
                                           </p>
                                       </div>
                                   </div>
                               </div>
                           </div>

                       : <span></span>


               }

           </div>
        </div>

      );

  }

  getDoctorsListHtml(){
      var doctorsHtml = [];
      if(!this.state.doctorsList){
        return(
            <span></span>
        );
      }
      for(var index = 0 ; index < this.state.doctorsList.length; index+=3){
          doctorsHtml.push(this.getEachRowHtml1(this.state.doctorsList[index], this.state.doctorsList[index+1], this.state.doctorsList[index+2]));
      }

      return doctorsHtml;



  }

  getProfilePicImage(profilePicUrl){
      if(profilePicUrl){
        return(
              <img src={profilePicUrl} className="img-center profile-pic" />
        );
      }else{
        return(
          <div className="profile-picture profile-picture--style-2">
              <div className="flex flex-column items-center justify-center br2 ba bw3 b--white shadow-2 pa4 bg-gray2">
                    <svg aria-hidden="true" data-prefix="fas"
                        data-icon="user" role="img"
                        xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 448 512"
                         className="svg-inline--fa fa-user fa-w-14 fa-3x">

                         <path fill="currentColor"
                            d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z" >
                         </path>
                    </svg>
              </div>
          </div>
        )
      }
  }

  getEachDoctorWidgetHtml(doctorDetails){
      if(!doctorDetails){
        return(<span></span>);
      }

      return(
          <div className="block block--style-3">
                <div className="profile-picture profile-picture--style-2">
                    {this.getProfilePicImage(doctorDetails.profilePicUrl)}
                </div>

                <div className="block-body text-center">
                    <h3 className="heading heading-6 strong-600 mb-0 mb-0">{doctorDetails.fullName}</h3>
                    <h3 className="heading heading-light heading-sm strong-300">
                        {doctorDetails.currentDesignation ? doctorDetails.currentDesignation : "Designation: Not Updated"}
                    </h3>
                    <h3 className="heading heading-light heading-sm strong-300">
                        {doctorDetails.currentHospital ? doctorDetails.currentHospital : "Hospital: Not Updated"}
                    </h3>
                    <h3 className="heading heading-light heading-sm strong-300">
                        {doctorDetails.currentWorkingCity ? doctorDetails.currentWorkingCity : "Working City: Not Updated"}
                    </h3>

                </div>
                <div className="aux-info-wrapper border-top">
                    <ul className="aux-info">
                        <li className="heading strong-400 ">
                            <div className="row">
                                <div className="col-md-5 strong-600 pull-right">Fellowship: </div>
                                <div className="col-md-7 pull-left">{doctorDetails.fellowship ? doctorDetails.fellowship : "Not Updated" }</div>
                            </div>
                            <div className="row">
                                <div className="col-md-5 strong-600 pull-right">Post Graduation: </div>
                                <div className="col-md-7 pull-left">{doctorDetails.undergrad ? doctorDetails.undergrad : "Not Updated" }</div>
                            </div>
                            <div className="row">
                                <div className="col-md-5 strong-600 pull-right">Email Id: </div>
                                <div className="col-md-7 pull-left">{doctorDetails.emailId ? doctorDetails.emailId : "Not Updated" }</div>
                            </div>
                            <div className="row">
                                <div className="col-md-5 strong-600 pull-right">Phone Number: </div>
                                <div className="col-md-7 pull-left">{doctorDetails.phonenumber ? doctorDetails.phonenumber : "Not Updated" }</div>
                            </div>



                        </li>

                    </ul>
                </div>
          </div>
        );

  }

  getEachRowHtml1(doctor1, doctor2, doctor3){
    return(
        <div className="row cols-md-space cols-sm-space cols-xs-space mt-5">
              <div className="col-lg-4">
                  {this.getEachDoctorWidgetHtml(doctor1)}
              </div>

              <div className="col-lg-4">
                {this.getEachDoctorWidgetHtml(doctor2)}

              </div>

              <div className="col-lg-4">
                  {this.getEachDoctorWidgetHtml(doctor3)}
              </div>
        </div>
    );
  }

  render(){
    return(
          <div className="container">
              {this.getDoctorsListHtml()}
              <br />
              <br />
          </div>

    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/DoctorsList.js